export const setupConferenceChannel = (echo, channel, { commit, dispatch, state }) => {
  if (echo.connector.channels.hasOwnProperty(`private-${channel}`)) {
    return;
  }

  return echo
    .private(channel)
    .listen('.conference-session-updated', payload => {
      if (payload?.session?.id) {
        const session = state.flatSessions.find(session => session.id === payload.session.id);

        if (session) {
          session.in_progress = payload.session.in_progress;
          session.buttons = payload.session.buttons;

          dispatch("agendaStore/updateFlatSessionById",
            { id: session.id, session },
            { root: true }
          );
        }
      }

      if (payload?.conference?.buttons) {
        commit("agendaStore/updateAgendaButtons",
          { ...payload.conference.buttons },
          { root: true }
        );
      }

      if (payload?.conference?.id) {
        commit("updateConferenceStatus", payload?.conference?.has_ended);
      }
    })
    .listen('.system-notification-updated', payload => {
      commit("updateNotification", payload);
    })
    .error(error => {
      console.error(`Error on channel ${channel}:`, error);
    });
};

export const setupNotificationChannel = (echo, channel, { commit }) => {
  if (echo.connector.channels.hasOwnProperty(`private-${channel}`)) {
    return;
  }

  return echo
    .private(channel)
    .listen('.system-notification-updated', payload => {
      commit("updateNotification", payload);
    })
    .error(error => {
      console.error(`Error on channel ${channel}:`, error);
    });
};

export const setupAttendeeChannel = (echo, channel, { commit, dispatch, state }) => {
  if (echo.connector.channels.hasOwnProperty(`private-${channel}`)) {
    return;
  }

  return echo
    .private(channel)
    .listen('.attendee-status-updated', payload => {
      if (payload?.session?.id) {
        const session = state.flatSessions.find(session => session.id === payload.session.id);

        if (session) {
          session.in_progress = payload.session.in_progress;
          session.buttons = payload.session.buttons;

          dispatch("updateFlatSessionById", { id: session.id, session });
        }
      }

      if (payload?.conference?.buttons) {
        commit("updateAgendaButtons", payload.conference.buttons);
      }

      if (payload?.conference?.id) {
        commit("attendeeStore/updateConferenceStatus", payload?.conference?.has_ended, { root: true });
      }
    })
    .error(error => {
      console.error(`Error on channel ${channel}:`, error);
    });
};
